import { render, staticRenderFns } from "./SectionListOffices.vue?vue&type=template&id=5010c744&scoped=true&"
import script from "./SectionListOffices.vue?vue&type=script&lang=ts&"
export * from "./SectionListOffices.vue?vue&type=script&lang=ts&"
import style0 from "./SectionListOffices.vue?vue&type=style&index=0&id=5010c744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010c744",
  null
  
)

export default component.exports